import { getAllCountries } from "../../dispersions/config/countries.config";
import type { EnhancedCountry } from "../../dispersions/types/dispersions-api.types";

export const DEFAULT_COMMISSION = 5;
export const MIN_AMOUNT_COP = 10_000;

/**
 * ISO3 → currency table for the quoter's currency selector. It used to be fetched from the legacy PHP `GET
 * /utilities/countries`, but the response carried nothing the local country config doesn't already have — the
 * quoter only derives currency options from it. Static now: no fetch, no loading, no error.
 */
export const QUOTER_COUNTRIES: EnhancedCountry[] = [
  ...getAllCountries().map((country) => ({
    name: country.name,
    code: country.iso3,
    currency: country.currency,
    currencySymbol: country.currencySymbol,
    flag: country.flag,
    hasPayout: false,
  })),
  // Not in the dispersions config (no payout corridor), but the PHP catalog offered its currency here and
  // the native rates engine lists CRC.
  { name: "Costa Rica", code: "CRI", currency: "CRC", currencySymbol: "₡", flag: "CR", hasPayout: false },
];
